const facilityGroups = {
  list: {
    search: {
      placeholder: 'Search facility groups...',
    },
    actions: {
      viewDetails: 'View Details',
      create: 'New Group',
      delete: (count: number) => `${count} groups deleted successfully`,
    },
    columns: {
      name: 'Name',
      externalId: 'External ID',
      facilities: 'Facilities',
    },
    facilitiesCount: 'Facilities',
    status: {
      lastUpdate: 'Last update',
    },
    empty: {
      description: 'No facility groups created yet',
    },
    selected: (count: number) => `${count} selected`,
    aria: 'Facility groups list',
  },
  dialog: {
    createTitle: 'Create Facility Group',
    editTitle: 'Edit Facility Group',
    form: {
      name: {
        label: 'Name',
        required: 'Name is required',
      },
      externalId: {
        label: 'External ID',
        required: 'External ID is required',
      },
      facilities: {
        label: 'Facilities',
        required: 'Facilities are required',
      },
    },
    actions: {
      create: 'Create',
      update: 'Update',
      cancel: 'Cancel',
    },
    createSuccess: 'Facility group created successfully',
    updateSuccess: 'Facility group updated successfully',
    deleteSuccess: (count: number) =>
      `${count} facility groups deleted successfully`,
    genericError: 'An error occurred while saving the facility group',
  },
  errors: {
    loadingGroups: (message: string) =>
      `Error loading facility groups: ${message}`,
  },
};

const facilities = {
  list: {
    search: {
      placeholder: 'Search facilities...',
    },
    actions: {
      viewDetails: 'View Details',
      create: 'New Facility',
      delete: (count: number) => `${count} facilities deleted successfully`,
    },
    columns: {
      name: 'Name',
      type: 'Type',
      group: 'Facility Group',
    },
    selected: (count: number) => `${count} facilities selected`,
    aria: 'Facilities list',
  },
  dialog: {
    title: {
      create: 'Create Facility',
      edit: 'Edit Facility',
    },
    actions: {
      create: 'Create',
      update: 'Update',
      cancel: 'Cancel',
    },
  },
  form: {
    fields: {
      name: {
        label: 'Facility Name',
        placeholder: 'Enter facility name',
      },
      type: {
        label: 'Facility Type',
        placeholder: 'Enter facility type',
      },
      timezone: {
        label: 'Timezone',
        placeholder: 'Select timezone',
      },
      address: {
        streetAddress: {
          label: 'Street Address',
          placeholder: 'Enter street address',
        },
        city: {
          label: 'City',
          placeholder: 'Enter city',
        },
        state: {
          label: 'State',
          placeholder: 'Enter state',
        },
        country: {
          label: 'Country',
          placeholder: 'Enter country',
        },
        postalCode: {
          label: 'Postal Code',
          placeholder: 'Enter postal code',
        },
      },
    },
    messages: {
      createSuccess: 'Facility created successfully',
      updateSuccess: 'Facility updated successfully',
      error: 'An error occurred while saving the facility',
    },
  },
  messages: {
    deleteSuccess: (count: number) =>
      `${count} facilities deleted successfully`,
    error: 'An error occurred',
  },
  errors: {
    loadingFacilities: (message: string) =>
      `Error loading facilities: ${message}`,
  },
};

const logs = {
  rawPayloadParseError: 'Raw Payload (Parse Error)',
  unknownEventType: 'Unknown Event Type',
  unknownEvent: 'Unknown Event',
  noDataAvailable: 'No data available',
  events: {
    facilityCreated: 'Facility Created',
    facilityUpdated: 'Facility Updated',
    facilityDeleted: 'Facility Deleted',
    facilityGroupAssigned: 'Facility Group Assigned',
    facilityGroupRemoved: 'Facility Group Removed',
    facilityGroupCreated: 'Facility Group Created',
    facilityGroupUpdated: 'Facility Group Updated',
    facilityGroupDeleted: 'Facility Group Deleted',
  },
};

export const en = {
  facilityGroups,
  facilities,
  logs,
};
